import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateRate } from 'api/wage/updateRate'
import { wageRuleKeys } from './keys'

export const useUpdateRateMutation = (ruleId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (request: Parameters<typeof updateRate>[0]) =>
      updateRate(request),
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: wageRuleKeys.byId(ruleId),
      })
    },
  })
}
